export type DataProtectionFormValues = {
  dataPrivacyConsentAcceptance: boolean
  selectall: boolean
  allowPhoneAds: boolean
  allowMailAds: boolean
  allowProfilesCreation?: boolean
  termsAgreeCheckAgree: boolean
}

const getInitialValues = (): DataProtectionFormValues => {
  return {
    dataPrivacyConsentAcceptance: false,
    selectall: false,
    allowPhoneAds: false,
    allowMailAds: false,
    termsAgreeCheckAgree: false,
  }
}

export default getInitialValues
